var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrash = function SvgTrash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    stroke: "none",
    fillRule: "nonzero",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1h16v2H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 3l-3-3H6L3 3h10zM1 5v13a2.006 2.006 0 002 2h10a2.006 2.006 0 002-2V5H1zm5 13H4V7h2v11zm6 0h-2V7h2v11z"
  })))));
};
export default SvgTrash;